/**
 * Раздел «Водоснабжение»: виды точек и тип элемента каталога.
 *
 * Точка водоснабжения — то, между чем ведут трубы: стояк, откуда вода приходит
 * в квартиру, коллектор (гребёнка), где она делится по потребителям, и водорозетка —
 * вывод из стены, к которому потом прикрутят смеситель или шланг.
 */
import type { CatalogItem, StringEnumValue } from "../../types";
import type { WaterId } from "./ids";

/** Среда в трубе: на чертежах холодная вода всегда синяя, горячая — красная. */
export enum WaterMedium {
	/** Холодное водоснабжение (ХВС) */
	Cold = 0,
	/** Горячее водоснабжение (ГВС) */
	Hot = 1,
}

/** Вид точки водоснабжения — от него зависит роль в разводке и символ на плане. */
export enum WaterPointKind {
	/** Стояк: вода приходит из него, обычно в санузле */
	Riser = 0,
	/** Коллектор (гребёнка): от него к каждой точке своя труба */
	Manifold = 1,
	/** Водорозетка: вывод из стены под смеситель, унитаз, машину */
	Outlet = 2,
}

/**
 * Точка водоснабжения — объект на стене с высотой установки, как розетка,
 * плюс вид и среды, которые она принимает: к стояку ХВС горячую трубу не подвести,
 * к парной водорозетке подходят обе.
 */
export interface WaterCatalogItem extends CatalogItem {
	id: StringEnumValue<WaterId>;
	kind: WaterPointKind;
	media: readonly WaterMedium[];
}
